import { TopicApiFactory } from '@eloomi/eloomi-topics-persona-client/1.0';

import { authorizeClient } from '@/api/authorize-client';

const topicApiClient = authorizeClient(TopicApiFactory);

export function deleteTopicsBulk(ids: number[]) {
    return topicApiClient.deleteBulk(ids);
}
